package pt.at.oss.kotlin.manual.storage.common.relevantdates

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * RelevantDates Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class RelevantDates(
    var registrationReqDate: String? = null,
    var forecastStartDate: String? = null,
    var msidDecisionDate: String? = null
) : BaseRecord()
